import { Icon, IconsEnum } from 'components/Icons';
import React, { useEffect, useState } from 'react';
import { RootState, useAppDispatch } from 'lib/centralStore';
import {
  unsetCategoryValue,
  unsetFunctionalityValue,
  unsetLinesValue,
  unsetProducerValue,
  unsetVolatilityValue,
} from '../../slotArchiveSlice';

import { SlotArchiveFiltersModal } from '../slotArchiveFiltersModal';
import { SlotFilter } from 'features/slotArchive/SlotArchive';
import { Wrapper } from 'components/wrapper';
import { calculateAllSelectedFiltersTogether } from 'features/slotArchive/utils/utils';
import styles from './SlotArchiveFilters.module.scss';
import { useSelector } from 'react-redux';
import useWindowSize from 'hooks/useWindowSize';

export type SlotArchiveFiltersProps = {
  label: string;
  modalTitle: string;
  modalResetLabel: string;
  modalDismissLabel: string;
  modalFunctionalityFilter: SlotFilter;
  modalLinesFilter: SlotFilter;
  modalVolatilityFilter: SlotFilter;
  modalProducerFilter: SlotFilter;
  modalCategoryFilter: SlotFilter;
  handleFilterChange: Function;
  handleClickViewResults: Function;
  handleResetFilters: Function;
  handleClickRemoveSingleFilter: Function;
};

export const SlotArchiveFilters = ({
  label,
  modalTitle,
  modalResetLabel,
  modalDismissLabel,
  modalFunctionalityFilter,
  modalLinesFilter,
  modalVolatilityFilter,
  modalProducerFilter,
  modalCategoryFilter,
  handleFilterChange,
  handleClickViewResults,
  handleResetFilters,
  handleClickRemoveSingleFilter,
}: SlotArchiveFiltersProps) => {
  const { selectedFilters } = useSelector((store: RootState) => store.archiveSlot);
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [numberSelectedFilters, setNumberSelectedFilters] = useState<number>(0);

  const { isDesktop } = useWindowSize();

  let allFiltersValues = calculateAllSelectedFiltersTogether(selectedFilters);

  useEffect(() => {
    setNumberSelectedFilters(allFiltersValues.length);
  }, [allFiltersValues.length]);

  const handleClickSetFilters = (value: string) => {
    const { functionality, volatility, lines, producer, category } = selectedFilters;

    if (functionality.includes(value)) {
      dispatch(unsetFunctionalityValue(value));
    } else if (volatility.includes(value)) {
      dispatch(unsetVolatilityValue(value));
    } else if (lines.includes(value)) {
      dispatch(unsetLinesValue(value));
    } else if (producer.includes(value)) {
      dispatch(unsetProducerValue(value));
    } else if (category.includes(value)) {
      dispatch(unsetCategoryValue(value));
    }
  };

  const doReset = () => {
    handleResetFilters();
    setOpenModal(false);
  };
  return (
    <React.Fragment>
      <Wrapper noPaddingBottom noPaddingTop>
        <div className={styles.container}>
          {isDesktop && numberSelectedFilters > 0 && (
            <div className={styles.filterContainer}>
              {allFiltersValues.map((filter) => {
                return (
                  <button
                    type="button"
                    key={filter}
                    className={styles.filterBtn}
                    onClick={() => {
                      handleClickRemoveSingleFilter(filter);
                      handleClickSetFilters(filter);
                    }}
                  >
                    {filter}
                    <Icon iconId={IconsEnum.CANCEL} className={styles.closeIcon} color="var(--color-primary)" />
                  </button>
                );
              })}
              <button type="button" className={styles.resetBtn} onClick={doReset}>
                RESET
              </button>
            </div>
          )}
          <button type="button" className={styles.button} onClick={() => setOpenModal(true)}>
            <Icon iconId={IconsEnum.FILTER} className={styles.icon} color="var(--color-on-bg-primary)" />
            {label}
            {numberSelectedFilters > 0 && <span className={styles.number}>({numberSelectedFilters})</span>}
          </button>
        </div>
      </Wrapper>

      <SlotArchiveFiltersModal
        isOpen={openModal}
        title={modalTitle}
        resetLabel={modalResetLabel}
        linesFilter={modalLinesFilter}
        categoryFilter={modalCategoryFilter}
        producerFilter={modalProducerFilter}
        volatilityFilter={modalVolatilityFilter}
        dismissModalLabel={modalDismissLabel}
        handleFilterChange={handleFilterChange}
        functionalityFilter={modalFunctionalityFilter}
        handleClickViewResults={handleClickViewResults}
        setOn={setOpenModal}
        handleResetClick={doReset}
      />
    </React.Fragment>
  );
};
